import { Box } from '@bonusly/design-system';

import { useBizyMascotActive } from '../bizy/use-bizy-mascot-active';

const BARS = [
	{ color: '#fc41ff', width: '85%', left: '-10%', duration: '22s', delay: '0s' },
	{ color: '#d3ff32', width: '70%', left: '20%', duration: '26s', delay: '-8s' },
	{ color: '#0cffe7', width: '95%', left: '-5%', duration: '18s', delay: '-14s' },
	{ color: '#7733ff', width: '65%', left: '30%', duration: '24s', delay: '-4s' },
];

type BizyAmbientGlowProps = {
	// Per-bar opacity. Defaults to the web side-panel strength; the desktop
	// shell dials it down because it wraps a larger area (bee + composer).
	opacity?: number;
};

export function BizyAmbientGlow({ opacity = 0.3 }: BizyAmbientGlowProps = {}) {
	// Pause the perpetual drift (and release its compositor layers) whenever the
	// window is unfocused or hidden, so a Bizy window left open behind others
	// stops burning CPU/GPU on a wash nobody is looking at (BIZY-661).
	const active = useBizyMascotActive();

	return (
		<Box
			position="absolute"
			top="0px"
			left="-10px"
			right="-10px"
			bottom="-8px"
			overflow="hidden"
			borderRadius="18px"
			filter="blur(56px)"
			pointerEvents="none"
			zIndex={0}
		>
			{BARS.map((bar, i) => (
				<Box
					key={i}
					position="absolute"
					top={0}
					left={bar.left}
					width={bar.width}
					height="100%"
					bg={bar.color}
					opacity={opacity}
					sx={{
						[`@keyframes drift${i}`]: {
							'0%': { transform: 'translateX(-30%)' },
							'50%': { transform: 'translateX(30%)' },
							'100%': { transform: 'translateX(-30%)' },
						},
						animation: `drift${i} ${bar.duration} ease-in-out ${bar.delay} infinite`,
						animationPlayState: active ? 'running' : 'paused',
						willChange: active ? 'transform' : 'auto',
					}}
				/>
			))}
		</Box>
	);
}
